import gql from 'graphql-tag';

/**
 * 获取店铺数据
 */
export const fetchActiveChannelDocument = gql`
  query activeChannel {
    activeChannel {
      id
      customFields {
        shopName
        shopLogo
        updateShippingAddressLimitTime
        amount
        points
      }
    }
  }
`;
